module.exports = __webpack_public_path__ + "img/Mapa-con-ubicacion.cfa232b3.jpg";